import { RichTextInput } from 'ra-input-rich-text';
import { DateInput, DateTimeInput, Edit, FormDataConsumer, SelectInput, SimpleForm, TextInput, required } from 'react-admin';
import {FileInput} from '../fileinputs/eventFileUpload';
import { MyRichTextInput } from './utils';


export function EventEdit(props) {
    return (
        <Edit  {...props}>
            <SimpleForm>
                <TextInput source="name" validate={required()} />
                {/* <TextInput source="description" /> */}

                <MyRichTextInput source="description" />
                <TextInput source="textDescription" multiline />


                <SelectInput source="type" choices={[
                    { id: "online", name: "Online" },
                    { id: "offline", name: "Offline" },
                ]} validate={required()} />
                <TextInput source="city"  validate={required()}/>
                <TextInput source="externalLink"  type="url"/>
                <FormDataConsumer>
                    {({ formData, ...rest }) => <TextInput source="location" {...rest} label={formData.type === 'offline' ? 'Location Link' : 'Meeting Link'} />}
                </FormDataConsumer>
                <DateTimeInput source='startDate' validate={required()} />
                <DateTimeInput source='endDate'  />
                <FileInput source="images" edit add />
            </SimpleForm>
        </Edit>
    )
}




